import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface PreviousActionState {
  PreviousAction: {
    load: boolean;
    data: [];
  };
}

export const PreviousActionSlice = createSlice({
  name: "PreviousAction",
  initialState: {
    PreviousAction: {
      load: false,
      data: [],
    },
  } as PreviousActionState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchPreviousAction.pending, (state: PreviousActionState) => {
        state.PreviousAction.load = true;
      })
      .addCase(fetchPreviousAction.fulfilled, (state: PreviousActionState, action: any) => {
        state.PreviousAction.data = action.payload;
        state.PreviousAction.load = false;
      })
      .addCase(fetchPreviousAction.rejected, (state: PreviousActionState) => {
        state.PreviousAction.load = false;
      });
  },
});

export default PreviousActionSlice.reducer;

export const fetchPreviousAction = createAsyncThunk(
  "PreviousAction/fetchPreviousAction",
  async (param: {apiParam: {id: any}}, thunkAPI) => {
    try {
      const { data } = await DataServer.post("api/editAction", {
        reported_issue_pin: param.apiParam.id
      });
      return data.data;
    } catch (error) {
    }
  }
);
